import MyAxios from "@/utilize/MyAxios";
import { useQuery } from "@tanstack/react-query";
import { TQueryOptions } from "@/@types/axios";
import { IUserResponse } from "@/features/admins/types";

export const useGetUserById = (userId: string, options: TQueryOptions = {}) => {
  return useQuery({
    queryKey: ["user", userId],
    queryFn: () =>
      MyAxios.get<IUserResponse>(`/users/${userId}`).then((res) => res.data),
    ...options,
  });
};
